module.exports = __webpack_public_path__ + "img/zuopindatu.e732ddc2.png";